import React from 'react';
import './FooterBottom.css';

const FooterBottom = () => (
  <footer className="footer-container">
    {/* Main footer content */}
    <div className="footer-content">
      {/* Footer Links Section */}
      <div className="footer-links">
        <div className="footer-links-row">
          <ul className="footer-link-col">
            <li><a href="/query" aria-label="Contact Us">Contact Us</a></li>
            <li><a href="/about-us" aria-label="About Us">About Us</a></li>
          </ul>
          <ul className="footer-link-col">
            <li><a href="/query" aria-label="Short Term Courses">Short Term Courses</a></li>
            <li><a href="/about-us" aria-label="Job Term Courses">Job Term Courses</a></li>
          </ul>
          <ul className="footer-link-col">
            <li><a href="/query" aria-label="Customized Training">Customized Training</a></li>
            <li><a href="/about-us" aria-label="Batch Scheduel">Batch Schedule</a></li>
          </ul>
          <ul className="footer-link-col">
            {/* <li><a href="/batchscheduel" aria-label="Other Batch Schedule">Batch Schedule</a></li> */}
            <li><a href="/#" aria-label="Privacy Policy">Privacy Policy</a></li>
          </ul>
        </div>
      </div>

      {/* Address and Contact Info Section */}
      <div className="footer-contact-info" style={{backgroundColor:'#DBDBDB'}}>
        <div className="footer-contact-details">
          <p style={{color:'black' , fontSize:'13px'}}><strong>Address:</strong> Chosen IT Academy, 32, S 2nd St, Shalimar Garden, Anna Enclave, Injambakkam, Chennai, Tamil Nadu 600115</p>
          <p style={{color:'black' ,  fontSize:'13px'}} className='footem'>
            <strong >Email:</strong> info@chosenacademy.co.in     
             <strong>    Phone:  </strong> +91-9962690905
          </p>
        </div>
      </div>
    </div>
  </footer>
);

export default FooterBottom;
